"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_SOURCE = exports.ICONS_ID = void 0;
const ICONS_ID = {
  '4G': '4G',
  '4Gplus': '4Gplus',
  '24h': '24h',
  Abierto: 'Abierto',
  Accesibilidad: 'Accesibilidad',
  Accion: 'Accion',
  Ahorro: 'Ahorro',
  ArrowUpDown: 'ArrowUpDown',
  AhorroMovil: 'AhorroMovil',
  Ajustes: 'Ajustes',
  Alerta: 'Alerta',
  AMC: 'AMC',
  AnadirMas: 'AnadirMas',
  Apagar: 'Apagar',
  AppleTv: 'AppleTv',
  ArrowLeftRight: 'ArrowLeftRight',
  AtClientes: 'AtClientes',
  Aura: 'Aura',
  Auriculares: 'Auriculares',
  Ayuda: 'Ayuda',
  AyudaPregunta: 'AyudaPregunta',
  Bateria: 'Bateria',
  BBDD: 'BBDD',
  Blog: 'Blog',
  BigAlarm: 'BigAlarm',
  Bombilla: 'Bombilla',
  Buscar: 'Buscar',
  Camara: 'Camara',
  CamaraSeguridad: 'CamaraSeguridad',
  CasaSegura: 'CasaSegura',
  CasaCamara: 'CasaCamara',
  Calendario: 'Calendario',
  CalidadServicio: 'CalidadServicio',
  CanalCero: 'CanalCero',
  CallCenter: 'CallCenter',
  CalleTrece: 'CalleTrece',
  Campana: 'Campana',
  Cerrar: 'Cerrar',
  Chat: 'Chat',
  CheuronDown: 'CheuronDown',
  CheuronUp: 'CheuronUp',
  CheuronRight: 'CheuronRight',
  CheuronLeft: 'CheuronLeft',
  CircleCheuron: 'CircleCheuron',
  Cine: 'Cine',
  CineIcon: 'CineIcon',
  CineN: 'CineN',
  CineRock: 'CineRock',
  CitaTienda: 'CitaTienda',
  ClaveWifi: 'ClaveWifi',
  Clasicos: 'Clasicos',
  Clic: 'Clic',
  Cloud: 'Cloud',
  Comedia: 'Comedia',
  ComedyCentral: 'ComedyCentral',
  Compartir: 'Compartir',
  Comprar: 'Comprar',
  ComprarPlanes: 'ComprarPlanes',
  CompraSegura: 'CompraSegura',
  ComprarDatos: 'ComprarDatos',
  ConfianzaOnline: 'ConfianzaOnline',
  Configuracion: 'Configuracion',
  ConfiguracionCorreo: 'ConfiguracionCorreo',
  ConfiguracionRouter: 'ConfiguracionRouter',
  ConfigurarMovil: 'ConfigurarMovil',
  ConsultaCanjes: 'ConsultaCanjes',
  ConsultaDocumento: 'ConsultaDocumento',
  Consumo: 'Consumo',
  ControlDirecto: 'ControlDirecto',
  Coffee: 'Coffee',
  CorazonSalud: 'CorazonSalud',
  CursorSolido: 'CursorSolido',
  Dark: 'Dark',
  Datos: 'Datos',
  DatosMoviles: 'DatosMoviles',
  Dazn: 'Dazn',
  Dazn1: 'Dazn1',
  Dazn2: 'Dazn2',
  DaznF1: 'DaznF1',
  Deporte: 'Deporte',
  Deporte1: 'Deporte1',
  Deporte2: 'Deporte2',
  DeporteIcon: 'DeporteIcon',
  Descargar: 'Descargar',
  DescargarApp: 'DescargarApp',
  DatosDescarga: 'DatosDescarga',
  Desco: 'Desco',
  DescoMando: 'DescoMando',
  DetalleLlamadas: 'DetalleLlamadas',
  Dialogando: 'Dialogando',
  Directorio: 'Directorio',
  Disney: 'Disney',
  DisneyBig: 'DisneyBig',
  Documento: 'Documento',
  Dual: 'Dual',
  Drama: 'Drama',
  Ecologico: 'Ecologico',
  Edificio: 'Edificio',
  Envio: 'Envio',
  Error: 'Error',
  Equipo: 'Equipo',
  EscudoSeguro: 'EscudoSeguro',
  Estrenos: 'Estrenos',
  Estrenos2: 'Estrenos2',
  Euro: 'Euro',
  EuroCirculo: 'EuroCirculo',
  Eurosport: 'Eurosport',
  Experto: 'Experto',
  Express: 'Express',
  Facebook: 'Facebook',
  Factura: 'Factura',
  Familia: 'Familia',
  Favorito: 'Favorito',
  Fest: 'Fest',
  Fibra: 'Fibra',
  Fijo: 'Fijo',
  FijoInternet: 'FijoInternet',
  Filtro: 'Filtro',
  Formula1: 'Formula1',
  Foro: 'Foro',
  Fox: 'Fox',
  FoxLife: 'FoxLife',
  FundacionTelefonica: 'FundacionTelefonica',
  Fusion: 'Fusion',
  FutbolIcon: 'FutbolIcon',
  Futbol: 'Futbol',
  Grabar: 'Grabar',
  GrabacionRemota: 'GrabacionRemota',
  Global: 'Global',
  Golf: 'Golf',
  Hd: 'Hd',
  Hgu: 'Hgu',
  Hollywood: 'Hollywood',
  Home: 'Home',
  HomeDoor: 'HomeDoor',
  Hogar: 'Hogar',
  Juego: 'Juego',
  Inhibicion: 'Inhibicion',
  Informacion: 'Informacion',
  Instagram: 'Instagram',
  Internet: 'Internet',
  InternetMovil: 'InternetMovil',
  LaLiga: 'LaLiga',
  Lanzamiento: 'Lanzamiento',
  LanzarYVer: 'LanzarYVer',
  LigaCampeones: 'LigaCampeones',
  LineaAdicional: 'LineaAdicional',
  Linkedin: 'Linkedin',
  LaResistencia: 'LaResistencia',
  LlamadaEntrante: 'LlamadaEntrante',
  LlamadaEspera: 'LlamadaEspera',
  LlamadaSaliente: 'LlamadaSaliente',
  Mas80: 'Mas80',
  Mdh: 'Mdh',
  MeGusta: 'MeGusta',
  MensDictados: 'MensDictados',
  Menu: 'Menu',
  Minutos: 'Minutos',
  MisPedidos: 'MisPedidos',
  Mix: 'Mix',
  Mix2: 'Mix2',
  Mosaico: 'Mosaico',
  Motor: 'Motor',
  MotorIcon: 'MotorIcon',
  Movil: 'Movil',
  MovilPlay: 'MovilPlay',
  MovilRoaming: 'MovilRoaming',
  MovilSeguro: 'MovilSeguro',
  Movistar: 'Movistar',
  MovistarCar: 'MovistarCar',
  MovistarCircular: 'MovistarCircular',
  MovistarLikes: 'MovistarLikes',
  MpaUp: 'MpaUp',
  Multicontenido: 'Multicontenido',
  MultiDispositivo: 'MultiDispositivo',
  Multipantalla: 'Multipantalla',
  Mundo: 'Mundo',
  Mpa: 'Mpa',
  Netflix: 'Netflix',
  Noticias: 'Noticias',
  NoVer: 'NoVer',
  Nube: 'Nube',
  Oferta: 'Oferta',
  OfertasExclusivas: 'OfertasExclusivas',
  Offline: 'Offline',
  Ok: 'Ok',
  Ont: 'Ont',
  Opciones: 'Opciones',
  PagarFacturas: 'PagarFacturas',
  PagoOnline: 'PagoOnline',
  Pantalla: 'Pantalla',
  Partidazo: 'Partidazo',
  Perfil: 'Perfil',
  Picture: 'Picture',
  Play: 'Play',
  Portatil: 'Portatil',
  Premium: 'Premium',
  PriorityUser: 'PriorityUser',
  Producto: 'Producto',
  Procesador: 'Procesador',
  Qustodio: 'Qustodio',
  RealMadrid: 'RealMadrid',
  RechazoLlamada: 'RechazoLlamada',
  ReclamarFactura: 'ReclamarFactura',
  Reloj: 'Reloj',
  Restar: 'Restar',
  Restart: 'Restart',
  RestarBola: 'RestarBola',
  Retroceder: 'Retroceder',
  Roaming: 'Roaming',
  Router: 'Router',
  Satelite: 'Satelite',
  Sagas: 'Sagas',
  Seguridad: 'Seguridad',
  SeguridadAbierta: 'SeguridadAbierta',
  SeriesMania: 'SeriesMania',
  SeguroMovil: 'SeguroMovil',
  Series: 'Series',
  Series2: 'Series2',
  SeriesIcon: 'SeriesIcon',
  SeriesExtras: 'SeriesExtras',
  ServicioTecnicoMovil: 'ServicioTecnicoMovil',
  Signos: 'Signos',
  Shield: 'Shield',
  ShieldOk: 'ShieldOk',
  Sim: 'Sim',
  SinConexion: 'SinConexion',
  Sms: 'Sms',
  SoporteTecnico: 'SoporteTecnico',
  Sordos: 'Sordos',
  SmartWatch: 'SmartWatch',
  Star: 'Star',
  Svo: 'Svo',
  SundanceTv: 'SundanceTv',
  Sumar: 'Sumar',
  SumarBola: 'SumarBola',
  SYFY: 'SYFY',
  TarjetaCredito: 'TarjetaCredito',
  Tc: 'Tc',
  TaquillaUp: 'TaquillaUp',
  TCM: 'TCM',
  Tokens: 'Tokens',
  TarjetaMemoria: 'TarjetaMemoria',
  Telefonica: 'Telefonica',
  TelefonicaFanshop: 'TelefonicaFanshop',
  Tiendas: 'Tiendas',
  Tittle: 'Tittle',
  Tuenti: 'Tuenti',
  Ubicacion: 'Ubicacion',
  UHD: 'UHD',
  U7D: 'U7D',
  Tv: 'Tv',
  Tdt: 'Tdt',
  TelefonicaEmph1: 'TelefonicaEmph1',
  TelefonicaEmph2: 'TelefonicaEmph2',
  TelefonicaHorizontal: 'TelefonicaHorizontal',
  TelefonicaVertical: 'TelefonicaVertical',
  TelefonicaVertical1: 'TelefonicaVertical1',
  Twitter: 'Twitter',
  U7dlabel: 'U7dlabel',
  Upload: 'Upload',
  Usuario: 'Usuario',
  Vamos: 'Vamos',
  Vacaciones: 'Vacaciones',
  Ver: 'Ver',
  Video: 'Video',
  ViolenciaDeGenero: 'ViolenciaDeGenero',
  Vigilancia: 'Vigilancia',
  VO: 'VO',
  VOD: 'VOD',
  VOS: 'VOS',
  Whatsapp: 'Whatsapp',
  Wifi: 'Wifi',
  Xtra: 'Xtra',
  Youtube: 'Youtube',
  BlogThink: 'BlogThink',
  Check: 'Check',
  Comunidad: 'Comunidad',
  MovilSim: 'MovilSim',
  VeriSign: 'VeriSign',
  ConTuNegocio: 'ConTuNegocio',
  BlogThinkLogo: 'BlogThinkLogo',
  ComunidadLogo: 'ComunidadLogo',
  Gestion: 'Gestion',
  Smily: 'Smily',
  BigData: 'BigData',
  Formacion: 'Formacion',
  VisitaComercial: 'VisitaComercial',
  '5GMovistar': '5GMovistar',
  '5GPunto': '5GPunto',
  MovilRobo: 'MovilRobo',
  MovilDanoAccidental: 'MovilDanoAccidental'
};
exports.ICONS_ID = ICONS_ID;
const ICON_SOURCE = {};
exports.ICON_SOURCE = ICON_SOURCE;
ICON_SOURCE[ICONS_ID.Abierto.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Accesibilidad.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Ahorro.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AhorroMovil.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Ajustes.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Alerta.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AMC.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AnadirMas.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Apagar.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AppleTv.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ArrowLeftRight.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AtClientes.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Aura.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Auriculares.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Ayuda.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.AyudaPregunta.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.BBDD.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Blog.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Bombilla.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Buscar.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CasaSegura.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Calendario.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CanalCero.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CallCenter.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CalleTrece.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Campana.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Cerrar.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Chat.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CheuronDown.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CheuronUp.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CheuronRight.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CheuronLeft.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CircleCheuron.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Cine.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CineIcon.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CineN.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CineRock.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ClaveWifi.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Clic.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Comedia.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ComedyCentral.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Compartir.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Comprar.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ComprarDatos.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ComprarPlanes.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CompraSegura.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Configuracion.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ConfiguracionCorreo.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ConfiguracionRouter.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ConfigurarMovil.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ConsultaCanjes.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ConsultaDocumento.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Consumo.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.ControlDirecto.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.CorazonSalud.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Dark.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Datos.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.DatosMoviles.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Deporte.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Deporte1.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Deporte2.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.DeporteIcon.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Descargar.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.DescargarApp.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Desco.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.DescoMando.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.DetalleLlamadas.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Directorio.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Documento.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Dual.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Ecologico.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Envio.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Error.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Estrenos.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Euro.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.EuroCirculo.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Eurosport.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Facebook.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Factura.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Familia.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Favorito.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Fibra.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Fijo.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.FijoInternet.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Filtro.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Formula1.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Foro.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Fox.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.FoxLife.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.FundacionTelefonica.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Fusion.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Futbol.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.FutbolIcon.toLowerCase()] = {
  l: '0',
  m: '0',
  s: '0'
};
ICON_SOURCE[ICONS_ID.Global.toLowerCase()] = '0';
/* ICON1 */

ICON_SOURCE[ICONS_ID.Grabar.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.GrabacionRemota.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Disney.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Golf.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Hd.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Hgu.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Hollywood.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Home.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.HomeDoor.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Hogar.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Juego.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Inhibicion.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Informacion.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Instagram.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Internet.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.InternetMovil.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LaLiga.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Lanzamiento.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LanzarYVer.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LigaCampeones.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LineaAdicional.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Linkedin.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LlamadaEntrante.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LlamadaEspera.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.LlamadaSaliente.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Mas80.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Mdh.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MeGusta.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MensDictados.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Mosaico.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Motor.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MotorIcon.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Movil.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Movistar.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MovistarCar.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MovistarCircular.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MovistarLikes.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MpaUp.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Multicontenido.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.MultiDispositivo.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Multipantalla.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Netflix.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Noticias.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.NoVer.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Nube.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Oferta.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.OfertasExclusivas.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Offline.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Ok.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Ont.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Opciones.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.PagarFacturas.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.PagoOnline.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Partidazo.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Perfil.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Picture.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Play.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Portatil.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Premium.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.PriorityUser.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Producto.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Qustodio.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.RealMadrid.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.RechazoLlamada.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Reloj.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Router.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Satelite.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Seguridad.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SeguridadAbierta.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SeriesMania.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Series.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SeriesIcon.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SeriesExtras.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.ServicioTecnicoMovil.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Signos.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Sim.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SinConexion.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Sms.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SoporteTecnico.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Sordos.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Star.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Svo.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SundanceTv.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.SYFY.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.TarjetaCredito.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tc.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.TaquillaUp.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.TCM.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Telefonica.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.TelefonicaFanshop.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tiendas.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tittle.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tokens.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tuenti.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Tv.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Twitter.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Usuario.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Ubicacion.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Vamos.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Ver.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Video.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.ViolenciaDeGenero.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Vigilancia.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.VO.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.VOD.toLowerCase()] = {
  l: '2',
  m: '1',
  s: '2'
};
ICON_SOURCE[ICONS_ID.VOS.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Whatsapp.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Xtra.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.Youtube.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
ICON_SOURCE[ICONS_ID.VeriSign.toLowerCase()] = {
  l: '1',
  m: '1',
  s: '1'
};
/* ICON2 */

ICON_SOURCE[ICONS_ID.Series2.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Accion.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.CitaTienda.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Dialogando.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.DisneyBig.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Bateria.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.CalidadServicio.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Camara.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.CamaraSeguridad.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ConfianzaOnline.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Dazn.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Dazn1.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Dazn2.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.DaznF1.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Pantalla.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Procesador.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ReclamarFactura.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Restar.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Restart.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.RestarBola.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Retroceder.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Sumar.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.SumarBola.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TarjetaMemoria.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.BlogThink.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Check.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Comunidad.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilSim.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MisPedidos.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ConTuNegocio.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.BlogThinkLogo.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ComunidadLogo.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TelefonicaEmph1.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TelefonicaEmph2.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TelefonicaHorizontal.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TelefonicaVertical.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.TelefonicaVertical1.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID['4G'].toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID['4Gplus'].toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID['24h'].toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Minutos.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Roaming.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Wifi.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Experto.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Express.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Estrenos2.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Fest.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.LaResistencia.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Mundo.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Mpa.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Mix.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Mix2.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.DatosDescarga.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Clasicos.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Cloud.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.CursorSolido.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Gestion.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Smily.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.BigData.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Formacion.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Vacaciones.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Coffee.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilPlay.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilRoaming.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilSeguro.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.SeguroMovil.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Sagas.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.U7D.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.UHD.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.CasaCamara.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Drama.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Edificio.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Equipo.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.EscudoSeguro.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.VisitaComercial.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Menu.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Shield.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ShieldOk.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.ArrowUpDown.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.BigAlarm.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.BigAlarm.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Tdt.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.U7dlabel.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.Upload.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
}; // tdt

ICON_SOURCE[ICONS_ID['5GMovistar'].toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID['5GPunto'].toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilRobo.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.MovilDanoAccidental.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};
ICON_SOURCE[ICONS_ID.SmartWatch.toLowerCase()] = {
  l: '2',
  m: '2',
  s: '2'
};

//# sourceMappingURL=utils.js.map